<template>
  <div class="app-container">
    <Navigation />
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Navigation from './components/Navigation.vue'

// Main App component - JSP handles authentication
const route = useRoute()

onMounted(() => {
  console.log('App mounted successfully')
  console.log('Current route:', route.path)
  console.log('Current route name:', route.name)
  
  // Add debugging for schedule route
  if (route.path === '/schedule') {
    console.log('Schedule route detected!')
  }
  
  // Add debugging for staff route
  if (route.path === '/staff') {
    console.log('Staff route detected!')
  }
})
</script>

<style>
.app-container {
  min-height: 100vh;
  background: #f5f5f5;
}

.main-content {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.main-content.marketing-page {
  padding: 0;
  max-width: none;
  margin: 0;
}

@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
  }
}
</style>

<style>
.app-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  z-index: 1;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #f5f7fa;
}

/* Ensure no overlay blocking in Chrome */
#app > * {
  position: relative;
  z-index: 2;
}

/* Fix Chrome-specific z-index issues */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .login-page {
    position: relative;
    z-index: 10;
  }
  
  .login-container {
    position: relative;
    z-index: 11;
  }
  
  .login-card {
    position: relative;
    z-index: 12;
  }
  
  .login-form {
    position: relative;
    z-index: 13;
  }
  
  .login-form :deep(.el-input) {
    position: relative;
    z-index: 14;
  }
  
  .login-form :deep(.el-button) {
    position: relative;
    z-index: 15;
  }
}
</style>
